import { Typography } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import colors from 'helpers/colors'
import { useTranslation } from 'next-i18next'
import { FC, useMemo } from 'react'
import styled from 'styled-components'

type Props = {
  description?: string
  isExpandInformation: boolean
  setIsExpandInformation: () => void
}

export const DescriptionSection: FC<Props> = ({
  description,
  isExpandInformation,
  setIsExpandInformation,
}) => {
  const { xs } = useBreakpoint()
  const { t } = useTranslation()

  const buttonText = useMemo(() => {
    if (isExpandInformation) return t('閉じる')

    return xs ? t('詳細情報を見る') : t('もっと見る')
  }, [isExpandInformation, t, xs])

  return (
    <>
      <StyledTypographyWrapper isExpandInformation={isExpandInformation}>
        <Typography.Text
          style={{
            fontSize: '14px',
            lineHeight: 1.5,
            color: colors.black,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'pre-line',
          }}
        >
          {description}
        </Typography.Text>
      </StyledTypographyWrapper>
      <Typography.Text
        style={{
          fontSize: xs ? 16 : 14,
          lineHeight: 1.5,
          letterSpacing: xs ? 0.8 : 1,
          color: colors.black,
          textDecoration: 'underline',
          fontWeight: xs ? 'bold' : 'normal',
        }}
        onClick={setIsExpandInformation}
      >
        {buttonText}
      </Typography.Text>
    </>
  )
}

const StyledTypographyWrapper = styled.div<{ isExpandInformation: boolean }>`
  line-height: 1.5;
  ${({ isExpandInformation }) =>
    !isExpandInformation &&
    `
    .ant-typography {
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }`}
`
